<template>
  <div>
    <h5 class="headline">{{ $t("contract.venue_governing_law.headline") }}</h5>
    <p>{{ $t("contract.venue_governing_law.paragraph_one") }}</p>
    <p v-if="!eeaOrEu">{{ $t("contract.venue_governing_law.paragraph_two") }}</p>
    <p v-else>{{ $t("contract.venue_governing_law.paragraph_two_alternate") }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    eeaOrEu() {
      return this.$store.state.contract.venueGoverningLaw.eeaOrEu;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/VenueGoverningLawOutput.vue